<template>
  <card>
    <div v-show="items.length > 0" class="table-full-width table-responsive">
      <div style="">
        <table class="table">
          <thead>
          <th class="text-left">
            <div class="table-header">
              <div class="table-header-title">
                {{ 'teacher_class' | setText('Класс') }}
              </div>
            </div>
          </th>
          <th class="text-left">
            <div class="table-header">
              <div class="table-header-title">
                {{ 'subject' | setText('Предмет') }}
              </div>
            </div>
          </th>
          </thead>
          <tbody tag="tbody">
          <tr v-for="(item, key) in items" :key="key" width="auto">
            <td align="left" class=""><span>{{ item.class }}</span></td>
            <td align="left" class=""><span>{{ item.title }}</span></td>
          </tr>
          </tbody>
        </table>
      </div><!----></div>
    <div v-show="items.length === 0">
      <h3>{{ 'empty' | setText('Пусто') }}</h3>
    </div>
  </card>
</template>
<script>

import {cardContent} from "@/plugins/functions";

export default {
  name: "ClassesSubjects",
  props: ["id"],
  data() {
    return {
      items: []
    };
  },
  methods: {
    cardContent: cardContent,
  },
  async created() {
    this.items = await this.cardContent(`business/classes/${this.id}`)
  }
};
</script>
<style>
</style>
